import { ref, onMounted, onUnmounted, computed } from 'vue'

export function useTimer(initialTime = 60) {
  const timeLeft = ref(initialTime)
  let intervalId = null
  const isFinished = ref(false)

  const formattedTime = computed(() => {
    const minutes = Math.floor(timeLeft.value / 60)
    const seconds = timeLeft.value % 60
    return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`
  })

  const startTimer = () => {
    if (!intervalId) {
      isFinished.value = false
      timeLeft.value = initialTime
      intervalId = setInterval(() => {
        if (timeLeft.value > 0) {
          timeLeft.value -= 1
        } else {
          clearInterval(intervalId)
          isFinished.value = true
          intervalId = null
        }
      }, 1000)
    }
  }

  const stopTimer = () => {
    if (intervalId) {
      clearInterval(intervalId)
      intervalId = null
    }
  }

  const resetTimer = (newTime = initialTime) => {
    stopTimer()
    timeLeft.value = newTime
  }

  const restartTimer = () => {
    stopTimer()
    startTimer()
  }

  onMounted(() => {
    startTimer()
  })

  onUnmounted(() => {
    stopTimer()
  })

  return {
    timeLeft,
    startTimer,
    stopTimer,
    resetTimer,
    formattedTime,
    isFinished,
    restartTimer,
  }
}
